import { api } from './api';

export function fetchPeople() {
  return dispatch => {
    return api.get('/api/people').then(response => {
      dispatch({ type: 'PEOPLE_FETCHED', payload: response.data });
    });
  };
}

export function updatePerson(id, data) {
  return dispatch => {
    return api.put(`/api/people/${id}`, { people: data }).then(response => {
      dispatch({ type: 'PEOPLE_FETCHED', payload: response.data });
    });
  };
}

export function updatePeople(people) {
  return dispatch => {
    return api.put('/api/people', { people: people }).then(response => {
      dispatch({ type: 'PEOPLE_FETCHED', payload: response.data });
    });
  };
}
